//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AxiosErrorHandler from '@/mixins/AxiosErrorHandler'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import ProfileMethods from '@/mixins/ProfileMethods'
import { escrowStatuses, roleNames, taskStatuses } from 'ct-constants'
import NewApplicationModal from '~/components/tasks/NewApplicationModal'

export default {
  name: 'ApplyForTaskButton',
  components: {
    NewApplicationModal
  },
  mixins: [AxiosErrorHandler, ProfileMethods],
  props: {
    task: {
      type: Object,
      required: true
    },
    invitationId: {
      type: Number,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * Currently selected application
     * @returns {null}
     */
    application () {
      return this.$store.getters['freelancerApplications/selectedApplication']
    },

    /**
     * Is freelancer profile published
     */
    isPublished () {
      return this.$store.getters['user/isPublished']
    },

    /**
     * Is user confirmed
     */
    isConfirmed () {
      return this.$store.getters['user/isConfirmed']
    },

    /**
     * Is user logged in
     */
    isUserLoggedIn () {
      return this.$auth.loggedIn
    },

    /**
     * Check if user has freelancer profile
     */
    hasFreelancer () {
      return this.$store.getters['user/hasFreelancer']
    },

    /**
     * Is current user freelancer
     */
    isFreelancer () {
      return this.$store.getters['user/isFreelancer']
    },

    /**
     * Is current client owner of this task
     * @returns {boolean}
     */
    isOwner () {
      return this.$auth.user?.id === this.task?.owner?.userId
    },

    /**
     * Is apply button visible
     * @returns {boolean}
     */
    applyVisible () {
      return !this.loading &&
        !this.application &&
        !this.task?.externalUrl &&
        this.task?.status !== taskStatuses.FILLED &&
        this.task?.status !== taskStatuses.CLOSED &&
        !this.isOwner &&
        [escrowStatuses.NO_ESCROW, escrowStatuses.ESCROW_PENDING, escrowStatuses.ESCROW_SET, escrowStatuses.ESCROW_WITHDRAWN, escrowStatuses.ESCROW_WITHDRAWAL]
          .includes(this.task?.escrowStatus)
    },

    /**
     * Is go to application button visible
     * @returns {false|null|boolean}
     */
    goToApplicationVisible () {
      return !this.loading &&
        this.application &&
        !this.task?.externalUrl
    },

    /**
     * Link icon
     * @returns {IconDefinition}
     */
    linkIcon () {
      return faExternalLinkAlt
    },

    /**
     * External task URL
     * @returns {any}
     */
    externalUrl () {
      return this.task?.externalUrl
    },

    /**
     * Apply button text depends on invitation id
     * @returns {VueI18n.TranslateResult}
     */
    applyButtonText () {
      return this.invitationId ? this.$t('freelancers.acceptInvitation') : this.$t('freelancers.apply_for_job')
    }
  },
  methods: {
    /**
     * Check all the conditions and show modal if all conditions are met
     * @returns {Promise<void>}
     */
    async showApplicationModal () {
      if (!this.isUserLoggedIn) {
        await this.$router.replace(this.localePath('/sign-up'))
      } else {
        try {
          if (!this.isFreelancer) {
            const confirmation = await this.$bvModal.msgBoxConfirm(this.$t('clients.applyConfirmationModal'), {
              okTitle: this.$t('common.ok'),
              cancelTitle: this.$t('common.cancel'),
              centered: true
            })

            if (!confirmation) {
              return
            }
          }

          // if user has no freelancer, create it first
          if (!this.hasFreelancer) {
            await this.$store.dispatch('user/createFreelancer')
          }

          // if user is not freelancer switch role
          if (!this.isFreelancer) {
            await this.$store.dispatch('user/switchRole', roleNames.FREELANCER)
          }

          // check profile completeness
          if (await this.checkProfileCompleteness()) {
            // check if freelancer is confirmed and published
            if (!this.isConfirmed || !this.isPublished) {
              await this.$store.dispatch('ui/showNotification', {
                type: 'success',
                text: this.$t('freelancers.confirmed_warning')
              })
            } else {
              // if all fine open modal
              this.$refs.applicationModal.show()
            }
          }
        } catch (err) {
          await this.handleError(err)
        }
      }
    }
  }
}
